/**
 * eslint-disable max-len
 *
 * @format
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductSelectionState } from '@pdp/data-access/interfaces';

/**
 * @description Add To Cart State Selectors
 */

export const selectProductSelectionState =
	createFeatureSelector<ProductSelectionState>('productSelection');

export const selectAtcState = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart
);

export const selectAtcUserInputQty = createSelector(selectProductSelectionState, (state) =>
	Number(state.addToCart.userInputQuantity)
);

export const selectAtcFulfillmentOption = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart.fulfillmentOption
);

export const selectAtcSuccess = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart.success
);

export const selectIsMultipleProducts = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart.isMultipleProducts
);

export const selectAtcAirballMeassage = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart.airballMessage
);

export const selectInventoryExceededStatus = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart.inventoryExceededStatus
);

export const selectMaxOrMinQuantityAlert = createSelector(
	selectProductSelectionState,
	(state) => state.addToCart.maxOrMinQuantityAlert
);

export const selectWarrantyAddToExistingCartError = createSelector(
	selectAtcState,
	(state) => state.warrantyAddToExistingCartError
);
